import React from 'react'
import Form from '../Includes/Wrapper/Form'
import InputFonction from '../Includes/Input/InputFonction'
import {
  CheckTexte
} from '../../Functions/Check'

const FonctionModalContent = ({
  state,
  Commit,
  Update
}) => {
  const Fonction = (value) => {
    Update('existe', false)
    Update('fonction', value)
    Update('error', (
      (value !== '') &&
      (!CheckTexte(value))
    ))
  }
  return (
    <Form>
      <InputFonction
        data-testid="fonction-nom"
        setValue={Fonction}
        error={state.error}
        existe={state.existe}
        value={state.fonction}
        onKeyUp={(event) => {
          if (event.key === 'Enter') {
            Commit()
          }
        }}
      />
    </Form>
  )
}

export default FonctionModalContent
